"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var button_module_css_1 = __importDefault(require("./button.module.css"));
var Accent_1 = require("@nerdwallet/currency/components/Accent");
var preventDefaultAndStopPropagation = function (e) {
    e.preventDefault();
    e.stopPropagation();
};
var getDisabledProps = function (Component, disabled) {
    if (!disabled) {
        return {};
    }
    if (Component === "a") {
        return {
            tabIndex: -1,
            "aria-disabled": true,
            onMouseDown: preventDefaultAndStopPropagation,
            onClick: preventDefaultAndStopPropagation,
        };
    }
    // Otherwise, component is a <button>
    return {
        disabled: true,
    };
};
var Button = function (_a) {
    var _b;
    var _c = _a.block, block = _c === void 0 ? false : _c, children = _a.children, loading = _a.loading, darkBackground = _a.darkBackground, disabled = _a.disabled, href = _a.href, onClick = _a.onClick, secondary = _a.secondary;
    var Component = href ? "a" : "button";
    return (react_1.default.createElement(Component, __assign({ className: (0, classnames_1.default)(button_module_css_1.default.button, (_b = {},
            _b[button_module_css_1.default.blockDesktop] = typeof block === "object" ? block.desktop : block,
            _b[button_module_css_1.default.blockMobile] = typeof block === "object" ? block.mobile : block,
            _b[button_module_css_1.default.primary] = !secondary && !darkBackground,
            _b[button_module_css_1.default.secondary] = secondary && !darkBackground,
            _b[button_module_css_1.default.primaryOnDarkBackground] = !secondary && darkBackground,
            _b[button_module_css_1.default.secondaryOnDarkBackground] = secondary && darkBackground,
            _b[button_module_css_1.default.waitCursor] = loading,
            _b)), href: href, onClick: onClick }, getDisabledProps(Component, !!disabled)),
        react_1.default.createElement(Accent_1.Accent, null,
            react_1.default.createElement("p", { className: button_module_css_1.default.label }, children))));
};
exports.Button = Button;
exports.default = exports.Button;
